import { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { merge } from '../../utils/utility';
import { HeaderPage } from './SiteHeader';

interface Props {
  page: HeaderPage;
}

export const NavDrawerLink: FC<Props> = ({ page }) => {
  const baseClass = 'text-primary-800 border-b px-5 py-2';
  return (
    <NavLink className={({ isActive }) => merge(baseClass, isActive ? 'font-bold' : 'font-semibold')} to={page.url}>
      {page.name}
    </NavLink>
  );
};
